import {
  RouteTimetableData,
  TimetableIssue,
} from '../../types/mock-timetable-type';
import { BusRouteDataMap, DemoRegion } from '../constant/route-types';
import {
  timeStringAddSeconds,
  timeStringRemoveSeconds,
} from '../demo-utils/demo-timer';

export const alertTypes: TimetableIssue[] = [
  {
    type: 'MIDTRIP',
    level: 1,
  },
  {
    type: 'CURTAILMENT',
    level: 1,
  },
  {
    type: 'DIVERSION',
    level: 1,
  },
  {
    type: 'SKIP',
    level: 1,
  },
  {
    type: 'BREAKDOWN',
    level: 2,
  },
  {
    type: 'ACCIDENT',
    level: 2,
  },
  {
    type: 'OVERLOAD',
    level: 1,
  },
  {
    type: 'EMERGENCY',
    level: 1,
  },
];

export const createIssueTimetable = (
  timetables: RouteTimetableData[],
  routes?: BusRouteDataMap
) => {
  const timetableClone: RouteTimetableData[] = JSON.parse(
    JSON.stringify(timetables)
  );
  timetableClone.forEach(timetableRoute => {
    const { routeId, stopList, timetable } = timetableRoute;
    const selectedRouteBuses = routes[routeId]?.busArr;
    timetable.forEach(tt => {
      const { direction, trips } = tt;
      trips.forEach((trip, tripIndex) => {
        const { stops, vehicleId } = trip;
        trip.isStarted = true;

        let busId = '';
        if (selectedRouteBuses) {
          busId = selectedRouteBuses[tripIndex % selectedRouteBuses.length];
        } else {
          busId = vehicleId;
        }
        trip.vehicleId = busId;

        const assignedIssue = alertTypes?.[tripIndex] ?? undefined;
        const { type = undefined } = assignedIssue || {};

        if (assignedIssue) {
          trip.issue = assignedIssue;
          switch (type) {
            case 'MIDTRIP': {
              trip.issue.message = `Mid-trip Start: AV Bus did not start trip in the first bus stop.`;
              break;
            }
            case 'CURTAILMENT': {
              trip.issue.message = `Trip Curtailment: AV Bus trip ended before the last bus stop.`;
              break;
            }
            case 'DIVERSION': {
              trip.issue.message = `Diversion: AV Bus diverted around blockage.`;
              break;
            }
            case 'SKIP': {
              trip.issue.message = `Bus Stop Skipping: AV Bus omitted some bus stops.`;
              break;
            }
            case 'BREAKDOWN': {
              trip.issue.message = `Breakdown: AV Bus broke down during trip.`;
              break;
            }
            case 'ACCIDENT': {
              trip.issue.message = `Accident: AV Bus was involved in an accident.`;
              break;
            }
            case 'OVERLOAD': {
              trip.issue.message = `Passenger Overload: AV Bus exceeded passenger capacity.`;
              break;
            }
            case 'EMERGENCY': {
              trip.issue.message = `Emergency Button: Passenger pressed emergency button.`;
              break;
            }
            default:
              trip.issue.message = 'Unknown Issue';
          }
        }

        stops.forEach((stop, stopIndex) => {
          const { schArrTime } = stop;
          stop.schArrTime = timeStringRemoveSeconds(schArrTime);
          const randomSeconds = Math.floor(Math.random() * 61);
          stop.obsArrTime = timeStringAddSeconds(schArrTime, randomSeconds);
          stop.busRegNo = busId;
          stop.actualHeadway = '-';
          stop.planHeadway = '-';
          stop.headwayStatusColor = 'bgGray';
          stop.isAdded = true;
          stop.statusColor = 'on-time';

          if (assignedIssue) {
            if (
              assignedIssue.type === 'MIDTRIP' &&
              (stopIndex === 0 || stopIndex === 1)
            ) {
              stop.obsArrTime = null;
              stop.busRegNo = null;
              stop.actualHeadway = undefined;
              stop.planHeadway = undefined;
              stop.headwayStatusColor = undefined;
              stop.isAdded = undefined;
              stop.statusColor = undefined;
            } else if (
              assignedIssue.type === 'CURTAILMENT' &&
              stopIndex === stops.length - 1
            ) {
              stop.obsArrTime = null;
              stop.busRegNo = null;
              stop.actualHeadway = undefined;
              stop.planHeadway = undefined;
              stop.headwayStatusColor = undefined;
              stop.isAdded = undefined;
              stop.statusColor = undefined;
            } else if (
              assignedIssue.type === 'BREAKDOWN' &&
              stopIndex > Math.ceil((stops.length - 1) / 2)
            ) {
              stop.obsArrTime = null;
              stop.busRegNo = null;
              stop.actualHeadway = undefined;
              stop.planHeadway = undefined;
              stop.headwayStatusColor = undefined;
              stop.isAdded = undefined;
              stop.statusColor = undefined;
            } else if (
              assignedIssue.type === 'ACCIDENT' &&
              stopIndex >= Math.floor((stops.length - 1) / 2)
            ) {
              stop.obsArrTime = null;
              stop.busRegNo = null;
              stop.actualHeadway = undefined;
              stop.planHeadway = undefined;
              stop.headwayStatusColor = undefined;
              stop.isAdded = undefined;
              stop.statusColor = undefined;
            } else if (
              assignedIssue.type === 'SKIP' &&
              stopIndex > 0 &&
              stopIndex < stops.length - 1 &&
              stopIndex % 2 != 0
            ) {
              stop.obsArrTime = null;
              stop.busRegNo = null;
              stop.actualHeadway = undefined;
              stop.planHeadway = undefined;
              stop.headwayStatusColor = undefined;
              stop.isAdded = undefined;
              stop.statusColor = undefined;
            }
          }
        });
      });
    });
  });
  return timetableClone;
};
